// Pre-curated list of colors that are easy on the eyes and distinct
// Using Tailwind 400/500 shades which usually work well in both light and dark modes
export const CHART_COLORS = [
  "#60a5fa", // Blue 400
  "#34d399", // Emerald 400
  "#fbbf24", // Amber 400
  "#f87171", // Red 400
  "#a78bfa", // Violet 400
  "#22d3ee", // Cyan 400
  "#e879f9", // Fuchsia 400
  "#818cf8", // Indigo 400
  "#fb923c", // Orange 400
  "#a3e635", // Lime 400
];

export const AXIS_COLOR = "#94a3b8"; // Slate 400 - visible but subtle text
export const GRID_COLOR = "rgba(148, 163, 184, 0.1)"; // Very subtle grid

// Shared tooltip styles for all charts
export const TOOLTIP_STYLE = {
  backgroundColor: "#1a1a1f",
  border: "1px solid rgba(255, 255, 255, 0.1)",
  borderRadius: "8px",
  color: "#f4f4f5",
  padding: "8px 12px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
};

export const TOOLTIP_LABEL_STYLE = {
  color: "#f4f4f5",
  fontWeight: 600,
};

// Only use for single-series charts (multi-series get auto-colored by Recharts)
export const TOOLTIP_ITEM_STYLE = {
  color: "#f4f4f5",
};

/**
 * Format large numbers with magnitude suffix (K, M, B, T)
 * Uses 3 significant figures for readability
 */
export function formatLargeNumber(value: number): string {
  const absValue = Math.abs(value);
  const sign = value < 0 ? "-" : "";

  if (absValue >= 1e12) {
    return sign + (absValue / 1e12).toPrecision(3) + "T";
  }
  if (absValue >= 1e9) {
    return sign + (absValue / 1e9).toPrecision(3) + "B";
  }
  if (absValue >= 1e6) {
    return sign + (absValue / 1e6).toPrecision(3) + "M";
  }
  if (absValue >= 1e3) {
    return sign + (absValue / 1e3).toPrecision(3) + "K";
  }
  return value.toString();
}
